function setOrders(state, orders) {
  state.releasedOrders = orders;
}

function updateOrder(state, payload) {
  const {order, index} = payload;
  state.releasedOrders[index] = order;
}

function deleteOrder(state, orderId) {
  const index = state.releasedOrders.findIndex(order => order.id === orderId);
  state.releasedOrders.splice(index, 1);
}

function setCancellingOrders(state, orders) {
  state.cancellingOrders = orders;
}

function deleteCancellingOrder(state, orderId) {
  const index = state.cancellingOrders.findIndex(order => order.id === orderId);
  state.cancellingOrders.splice(index, 1);
}

function editCancellingOrder(state, payload) {
  const {orderId, key, value} = payload;
  const order = state.cancellingOrders.find(order => order.id === orderId);
  order[key] = value;
}

function setPendingPurchases(state, payload) {
  state.hasPendingPurchases = !!payload;
}

export default {
  setOrders,
  updateOrder,
  deleteOrder,
  setCancellingOrders,
  deleteCancellingOrder,
  editCancellingOrder,
  setPendingPurchases,
}
